import React, {useState} from 'react';
import {Input} from "../../../../shadCn/components/ui/input";
import SliderShowButton from "../../../../components/slide/SliderShowButton";
import DetailBtn from "../../../../components/slide/sub/button/DetailBtn";
import DeleteBtn from "../../../../components/slide/sub/button/DeleteBtn";
import CommonPagination from "../../../../components/table/movable/CommonPagination";
import ServiceApplyInfoSlide from "../../../../components/slide/sub/service/ServiceApplyInfoSlide";

function ServiceApplyThumbType ({data, handlePageChange, pageInfo}){
    const [searchTxt, setSearchTxt] =useState('');

    const inputListener=(e)=>{
        setSearchTxt(e.target.value);
    }

    //통합검색입력후 enter시 바로 검색할 수 있도록
    const handleOnKeyPress = e => {
        if (e.key === 'Enter') {

        }
    };


    const deleteAsset=()=>{
        alert("delete method should be implemented")
    }

    return (
        <div className="flex w-[100%]">
            <div className="list-container">
                <div className="list-container-top-search">
                    <Input value={searchTxt} onChange={inputListener} onKeyPress={handleOnKeyPress}  />
                </div>
                <div className="asset-thumbnail-container">
                    {data?.map(each =>(
                        <SliderShowButton
                            key={each.id}
                            data={each}
                            expose={70}
                            buttons={[<DetailBtn uri={`/serviceRequest/serviceApply/${each.id}`} />] }>

                            <ServiceApplyInfoSlide data={each} />

                        </SliderShowButton>
                    ))}
                </div>
                {data && data.length > 0 &&
                    <CommonPagination  page={pageInfo} onPageChange={handlePageChange}/>
                }
            </div>
        </div>
    );
};

export default ServiceApplyThumbType;